import axios from 'axios';
import { getSessionToken, clearSession, getDeviceToken } from './authStorage';

const BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && getSessionToken()) {
      clearSession();
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

// Axios instance authenticated with the long-lived DEVICE token, used only for
// the boot/profile-selection endpoints (device state, profiles, session login).
export const deviceApi = axios.create({ baseURL: `${BASE}/api` });
deviceApi.interceptors.request.use((config) => {
  const token = getDeviceToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BACKEND_URL = BASE;
export default api;
